import PropTypes from 'prop-types';
import React from 'react';
import { Box, Slide, Stack, Button, TextField, Typography } from '@mui/material';
import toast from 'react-hot-toast';
import _ from 'lodash';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import * as kategoriLayananService from '../../../services/kategorilayanan';
import RequestsPackages from './RequestsPackages';

RequestsHosting.propTypes = {
  user: PropTypes.object.isRequired,
  menu: PropTypes.string.isRequired,
  rekomendasis: PropTypes.object.isRequired,
  setMenu: PropTypes.func.isRequired
};

export default function RequestsHosting({ menu, user, rekomendasis, setMenu }) {
  const [packages, setPackages] = React.useState([]);
  const navigate = useNavigate();
  const theme = useTheme();

  // Get Paket
  const getPackage = async () => {
    try {
      const body = { id_layanan: menu.id };
      const result = await kategoriLayananService.getPaketLayanan(body);

      setPackages(result.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getPackage();
  }, [menu]);
  // End Get Paket

  const choosePackage = async (item) => {
    alert('test');
  };

  return (
    <>
      <Slide direction="left" in="true" mountOnEnter unmountOnExit>
        <Box sx={{ flexDirection: 'column' }}>
          <Stack spacing={3} direction="column">
            <RequestsPackages
              user={user}
              item={packages}
              handleClick={(item) => choosePackage(item)}
              rekomendasis={rekomendasis}
              setMenu={setMenu}
            />
          </Stack>
        </Box>
      </Slide>
    </>
  );
}
